import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule} from '@angular/material/button';
import { MatInputModule} from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule} from '@angular/material/card';
import { MatMenuModule} from '@angular/material/menu';
import { MatToolbarModule} from '@angular/material/toolbar';
import { MatIconModule} from '@angular/material/icon';
import { MatSidenavModule} from '@angular/material/sidenav';
import { MatListModule} from '@angular/material/list';
import { MatGridListModule} from '@angular/material/grid-list';
import { MatTableModule} from '@angular/material/table';
import { MatTooltipModule} from '@angular/material/tooltip';
// TODO use for testing
import { MatNativeDateModule } from '@angular/material/core'
import { MatDatepickerModule} from '@angular/material/datepicker';

import { MatProgressSpinnerModule } from 
    "@angular/material/progress-spinner";

import { MatCheckboxModule} from 
    '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { ScrollingModule } from '@angular/cdk/scrolling'; 

import { NotificationComponent} from './../notification/notification.component';
import { NotificationService} from './../notification/notification.service';
import { PopupNotificationComponent } from 
    '@app/secure/notification/popupNotification.component';
import { DocumentComponent } 
    from '@app/secure/share/document/document.component';
import { SignaturePadComponent } from 
    '@app/secure/share/signaturePad/signaturePad.component';
import { DocumentBadgeComponent }
    from '@app/secure/share/documentBadge/documentBadge.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MonthYearPickerComponent } from './datePicker/month/month.component';
import { DateRangePickerComponent } 
    from './datePicker/dateRange/dateRange.component';
import { MonthYearDirective } from '@app/secure/directive/monthYear.directive';
import { DateFormatDirective } from '@app/secure/directive/dateFormat.directive';
import { DateInputDirective } from '@app/secure/directive/DateInput.directive';
import { ZipCodeInputDirective } 
    from '@app/secure/directive/ZipCodeInput.directive';
import { ModuleTextCaseDirective } 
    from '@app/secure/directive/moduleTextCase.directive';
import { PhoneFormatDirective } 
    from '@app/secure/directive/phoneFormat.directive';
import { CurrencyInputDirective }
    from '@app/secure/directive/currencyInput.directive';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCheckboxModule,        
        MatRadioModule,
        MatInputModule,
        MatDialogModule,
        MatSelectModule,
        MatMenuModule,
        MatCardModule,
        MatToolbarModule,
        MatIconModule,
        MatSidenavModule,
        MatListModule,
        MatGridListModule,
        MatTableModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        ScrollingModule,
        MatAutocompleteModule,
        MatInputModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatNativeDateModule
    ],
//    declarations: [],
    
    
    declarations: 
    [
        NotificationComponent,
        PopupNotificationComponent,
        SignaturePadComponent,
        DocumentBadgeComponent,
        DocumentComponent,
        MonthYearPickerComponent,
        DateRangePickerComponent,
        MonthYearDirective,
        DateFormatDirective,
        DateInputDirective,
        ZipCodeInputDirective,
        ModuleTextCaseDirective,
        PhoneFormatDirective,
        CurrencyInputDirective
    ],

    exports: 
    [
        CommonModule, FormsModule, 
        MatButtonModule, MatCheckboxModule,
        MatRadioModule,
        MatInputModule, MatSelectModule,
        MatDialogModule, MatMenuModule, 
        MatCardModule, MatToolbarModule, 
        MatIconModule, MatSidenavModule, 
        MatListModule, MatGridListModule, 
        MatTableModule, MatTooltipModule, 
        MatProgressSpinnerModule, 
        MatDatepickerModule,
        ScrollingModule, 
        NotificationComponent, 
        PopupNotificationComponent, 
        SignaturePadComponent,
        MatAutocompleteModule,
        MatInputModule,
        MatFormFieldModule,
        MatProgressSpinnerModule, 
        DocumentBadgeComponent,
        DocumentComponent,
        MonthYearPickerComponent,
        DateRangePickerComponent,
        MonthYearDirective,
        DateFormatDirective,
        DateInputDirective,
        ZipCodeInputDirective,
        ModuleTextCaseDirective,
        PhoneFormatDirective,
        CurrencyInputDirective
    ],
    providers: 
    [  
        NotificationService
    ]
})
export class ShareModule { }
